import { useCallback, useMemo } from 'react'
import { useOrderState } from './useOrderState'
import Analytics from 'hooks/analytics/Analytics'
import { getPrescriptionType, PrescriptionResponse } from '@ca/common'
import { trpc } from 'api'
import { useCustomer } from 'hooks/useSession'

export const useSelectPrescription = () => {
  const setPrescriptionId = useOrderState((s) => s.setPrescriptionId)
  const selectedId = useOrderState((s) => s.order.prescriptionId)
  const utils = trpc.useUtils()
  const setPrescriptionData = utils.customer.prescriptions.byId.setData
  const customer = useCustomer()

  const customerId = customer?.id
  const select = useCallback(
    (prescription: PrescriptionResponse) => {
      const currentSelectedId = useOrderState.getState().order.prescriptionId
      if (currentSelectedId === prescription.id) {
        return
      }
      if (customerId) {
        setPrescriptionData(
          {
            customerId,
            prescriptionId: prescription.id,
          },
          prescription
        )
      }
      setPrescriptionId(prescription.id)
      Analytics.logEvent('prescription_selected', {
        prescriptionId: `${prescription.id}`,
        optometrist: prescription.optometrist_name || '',
        type: getPrescriptionType(prescription.name),
      })
    },
    [customerId, setPrescriptionId, setPrescriptionData]
  )

  return useMemo(
    () => ({
      select,
      selectedId,
    }),
    [select, selectedId]
  )
}
